import Config from './config';

export default function _(key, value = null, params = []) {

	var db = Config.translations;
	var translation = value;

	if(typeof value != 'string') {
		params = value;
		translation = key;
	}
	
	if (key !== null && value !== null) {
		translation = key;
	}

	var tKey = translation;

	if(db[tKey.toLowerCase()]) {
		translation = db[tKey.toLowerCase()];
	}

	for(var property in params) {
		var reg = new RegExp('\\{' + property + '\\}');
		var param = params[property];

		translation = translation.replace(reg, param);
	}

	return translation;
}


// WEBPACK FOOTER //
// ./src/modules/utils/translator.js